<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-row>
          <b-col md="10" class="my-1">
            <b-navbar-nav>
              <b-button @click="goBack" size="sm" variant="outline-secondary">
                <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
              </b-button>
            </b-navbar-nav>
            <h5 class="mt-1 mr-2">
              {{ $route.name }}
            </h5>
          </b-col>
          <b-col md="1">
            <b-button
              @click="showCheckboxes = !showCheckboxes"
              size="sm"
              variant="outline-primary"
            >
              Columns
            </b-button></b-col
          >
          <b-col md="1">
            <h5>
              <small v-if="isLoading == false">{{ data.length }} Entries</small>
            </h5>
          </b-col>

          <b-col
            md="2"
            v-for="option in formattedColumnHeaders"
            :key="option.value"
            v-if="showCheckboxes"
          >
            <input
              type="checkbox"
              :value="option.value"
              :id="option.value"
              v-model="selectedColumns"
              @change="applySelectedColumns"
            />
            <label :for="option.value">{{ option.text }}</label>
          </b-col>

          <b-col cols="12">
            <label>SpreadSheet ID<span class="error">*</span></label>
            <b-form-input
              id="spreadsheetId"
              v-model="spreadsheetId"
             @input="fetchData()"
            />
            <div class="table-responsive tableMain gutr">
              <div id="spreadsheet" ref="spreadsheetContainer"></div>
            </div>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import { ModelListSelect, MultiSelect } from "vue-search-select";
import CheckboxMultiSelect from "./CheckboxMultiSelect.vue"; // Adjust import as needed
import CustomLoader from "../common/customLoader.vue";
import { lastVisitPage, globalPermissionStatus } from "../../helper/collection";
import moment from "moment";
export default {
  name: "Spreadsheet",
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    this.$store.dispatch("setCurrentRoute", "/google-sheett");
    this.fetchData();
  },
  data() {
    return {
      spreadsheetId: "1wzLEd4oHYs0McGYWxy10p_GygqXV4B_4Tz-9e7MX-_0",
      data: [],
      colHeaders: [],
      columns: [],
      customHeaders: [],
      selectedColumns: [],
      isLoading: false,
      allData: [],
      showCheckboxes: false,
    };
  },
  mounted() {
    this.fetchData();
  },
  components: {
    MultiSelect,
    CheckboxMultiSelect,
    CustomLoader,
  },
  computed: {
    isDisabled() {
      return false;
    },
    formattedColumnHeaders() {
      return this.colHeaders.map((header) => ({
        text: header.replace(/_/g, " "),
        value: header,
      }));
    },
  },
  methods: {
    goBack() {
      window.history.go(-1);
    },
    formatDate(value) {
      if (typeof value === 'string' && value.startsWith('Date(')) {
        const date = new Date(parseInt(value.substring(5, value.length - 1)));
        return moment(date).format('YYYY-MM-DD');
      }
      return value;
    },
    fetchData() {
    //   const spreadsheetId = "1wzLEd4oHYs0McGYWxy10p_GygqXV4B_4Tz-9e7MX-_0";
      //   const spreadsheetId = "11ojnuMmZS_pkEUXRIcSK8rN84tIXGZEN";
      this.isLoading = true;
      const url = `https://docs.google.com/spreadsheets/d/${this.spreadsheetId}/gviz/tq?tqx=out:json`;

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const jsonData = text.match(/(?<=\().*(?=\))/)[0];
          const parsedData = JSON.parse(jsonData);

          this.colHeaders = parsedData.table.cols.map((col) =>
            col.label.replace(/\s+/g, "_").replace(/[\/]/g, "_").toUpperCase()
          );

          this.customHeaders = [...this.colHeaders];
          //   this.columns = this.customHeaders.map(header => ({ data: header }));
          this.selectedColumns = [...this.colHeaders];
          this.columns = this.selectedColumns.map((header) => ({ data: header }));

          this.data = parsedData.table.rows.map((row) => {
            const rowData = {};
            this.colHeaders.forEach((key, index) => {
              // rowData[key] = row.c[index] ? row.c[index].v : "";
              const cellValue = row.c[index] ? row.c[index].v : "";
              rowData[key] = this.formatDate(cellValue);
            });
            return rowData;
          });
          this.allData = [...this.data];
          this.initializeHandsontable();
          this.isLoading = false;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    initializeHandsontable() {
      const container = this.$refs.spreadsheetContainer;

      this.hot = new Handsontable(container, {
        data: this.data,
        colHeaders: this.selectedColumns,
        columns: this.columns,
        rowHeaders: true,
        stretchH: "all",
        width: "100%",
        height: "600px",
        licenseKey: "non-commercial-and-evaluation",
      });
    },

    applySelectedColumns() {
      const visibleColumns = this.colHeaders.filter((header) =>
        this.selectedColumns.includes(header)
      );

      const reorderedColumns = [
        ...this.selectedColumns.filter((col) => !visibleColumns.includes(col)),
        ...visibleColumns,
      ];

      const orderedData = this.allData.map((row) => {
        const rowData = {};
        reorderedColumns.forEach((col) => {
          rowData[col] = row[col] || "";
        });
        return rowData;
      });

      this.hot.updateSettings({
        colHeaders: reorderedColumns,
        columns: reorderedColumns.map((header) => ({ data: header })),
        data: orderedData,
      });
    },
    applySelectedColumnsBak() {
      const filteredData = this.allData.map((row) => {
        const rowData = {};
        this.selectedColumns.forEach((col) => {
          rowData[col] = row[col] || "";
        });
        return rowData;
      });

      this.columns = this.selectedColumns.map((header) => ({ data: header }));
      this.data = filteredData;

      if (this.hot) {
        this.hot.updateSettings({
          colHeaders: this.selectedColumns,
          columns: this.columns,
          data: filteredData,
        });
      } else {
        this.initializeHandsontable();
      }
    },
  },
};
</script>

<style>
/* Handsontable header styling */
.handsontable .htCore .ht_master .htCenter .htHeader {
  background-color: #f1f3f4; /* Light grey background color */
  color: #202124; /* Dark text color */
  font-weight: bold; /* Make header text bold */
  border: 1px solid #e0e0e0; /* Border color */
}

/* Row header styling */
.handsontable .htCore .ht_master .htCenter .htRowHeader {
  background-color: #e0e0e0; /* Light grey background color */
  color: #202124; /* Dark text color */
  border-right: 1px solid #e0e0e0; /* Border color */
}

/* Column header bottom border */
.handsontable .htCore .ht_master .htCenter .htColumnHeader {
  border-bottom: 1px solid #bdbdbd; /* Bottom border color */
}
</style>



// WEBPACK FOOTER //
// Spreadsheet.vue?64c1da9c